import React from "react";
import {LinkContainer} from "react-router-bootstrap";
import Nav from "react-bootstrap/Nav";
import './_static/Link.css';

function Link(props) {
    return (
        <LinkContainer to={props.link}>
            <Nav.Link className="link">
                {props.image && (<img className="linkImage" src={props.image} alt="Pridať"/>)}
                {props.label}
            </Nav.Link>
        </LinkContainer>
    )
}

export default Link
